import {
  USER_TYPE_LIST_SEARCH, USER_TYPE_LIST_SEARCH_FAILURE, USER_TYPE_LIST_SEARCH_SUCCESS, USER_TYPE_DELETE, USER_TYPE_DELETE_FAILURE, USER_TYPE_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    usertypes: [],
    usertypeListNextPage: null,
    usertypeListCurrentPage: null
  },
  getters: {
    usertypeList: state => {
      return state.usertypes
    },
    usertypeListNextPage: state => {
      return state.usertypeListNextPage
    },
    usertypeListCurrentPage: state => {
      return state.usertypeListCurrentPage
    }
  },
  actions: {
    [USER_TYPE_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/user_types'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_TYPE_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(USER_TYPE_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [USER_TYPE_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('USER_TYPE_DELETE:' + params.id)
      var data = params.data
      var url = '/master/user_types/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_TYPE_DELETE_FAILURE, res.data)
          } else {
            commit(USER_TYPE_DELETE_SUCCESS, {data: res.data, callback: params.callback})
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [USER_TYPE_LIST_SEARCH_FAILURE] (state, params) {
      console.log('USER_TYPE_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [USER_TYPE_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('USER_TYPE_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.usertypes = state.usertypes.concat(data.data)
        state.usertypeListCurrentPage = data.meta['current-page']
      } else {
        state.usertypes = data.data
        state.usertypeListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.usertypeListNextPage = data.links['next']
      } else {
        state.usertypeListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [USER_TYPE_DELETE_FAILURE] (state, data) {
      console.log('USER_TYPE_DELETE_FAILURE')
    },
    [USER_TYPE_DELETE_SUCCESS] (state, data) {
      console.log('USER_TYPE_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/usertype-list.js